import { FC, SVGProps } from 'react';

export const UnderlineIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.75 5C9.75 4.58579 9.41421 4.25 9 4.25C8.58579 4.25 8.25 4.58579 8.25 5V15C8.25 19.2802 11.7198 22.75 16 22.75C20.2802 22.75 23.75 19.2802 23.75 15V5C23.75 4.58579 23.4142 4.25 23 4.25C22.5858 4.25 22.25 4.58579 22.25 5V15C22.25 18.4518 19.4518 21.25 16 21.25C12.5482 21.25 9.75 18.4518 9.75 15V5ZM9 26.25C8.58579 26.25 8.25 26.5858 8.25 27C8.25 27.4142 8.58579 27.75 9 27.75H23C23.4142 27.75 23.75 27.4142 23.75 27C23.75 26.5858 23.4142 26.25 23 26.25H9Z"
			fill="currentColor"
		/>
	</svg>
);
